<template>
  <CFooter :fixed="true">
    <div>
      <a href="/" target="_blank">Tryout Admin</a>
      <span class="ml-1">&copy; {{new Date().getFullYear()}} Salembagroup.com.</span>
    </div>
		<div class="ml-auto">
      <span class="mr-1">{{version}}</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Powered by</span>
      <a>CoreUI</a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter',
	data() {
		return {
			version: process.env.VUE_APP_VERSION,
		}
	}
}
</script>
